<template>
  <div ref="fullpage">
    <!-- 第一屏：视频 -->
    <section class="fullpage-section section-video">
      <homeVideo></homeVideo>
    </section>

    <!-- 第二屏：轮播 -->
    <section class="fullpage-section section-swiper">
      <homeSwpier :goodList="goodList" style="height: 100%;width: 100%;"></homeSwpier>
    </section>

    <!-- 第三屏：引入独立地图组件（核心修改：替换原地图代码） -->
    <MapSection :type="1" />
    <MapSection :type="2" />

    <!-- 第四屏：联系我们 -->
    <section class="fullpage-section section-empty">
      <div class="section-empty-inner">
        <div class="section-empty-title">联系我们</div>
        <div class="empty-list">
          <div class="empty-list-item" v-for="(item, index) in contactList" :key="index">
            <div class="empty-title" style="text-align: center;width: 90%;margin: auto;margin-top: 40px;">{{ item.title
              }}</div>
            <div class="empty-tips" style="text-align: center;width: 90%;margin: auto;margin-top: 10px;">{{ item.tips }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 右侧导航点 -->
    <div class="page-dots">
      <span v-for="(dot, index) in 5" :key="index" class="dot" :class="{ active: activeIndex === index }"
        @click="scrollToSection(index)"></span>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

// 导入子组件（新增：导入独立地图组件）
import homeVideo from '@/components/home-video.vue'
import homeSwpier from '@/components/home-swpier.vue'
import MapSection from '@/components/MapSection.vue' // 引入地图组件

/** ---------------- 首页核心数据 ---------------- **/
// 联系我们数据
const contactList = ref([
  { title: "官方服务热线", tips: "400-183-9888" },
  { title: "商务合作", tips: "xxxxxx@hec.com" },
  { title: "官方公众号", tips: "官方公众号" },
  { title: "人才招聘", tips: "HR@hec.com" },
  { title: "附近门店", tips: "查询附近的门店 >" },
  { title: "公司地址", tips: "珠海市横琴新区粤澳合作中医药科技产业园飞鹏路30号5栋501室" },
])

// 轮播商品数据
const goodList = ref([
  {
    title: "特级冻干冬虫夏草28根",
    tips: "（产品级别：4600条/公斤）",
    type: "1",
    goodsImg: "https://youke1.picui.cn/s1/2025/08/30/68b2e47d58589.png"
  },
  {
    title: "特级冻干冬虫夏草36根",
    tips: "（产品级别：4600条/公斤）",
    type: "1",
    goodsImg: "https://youke1.picui.cn/s1/2025/08/27/68af1213e6c71.png"
  },
  {
    title: "一级冻干冬虫夏草20根",
    tips: "（产品级别：3200条/公斤）",
    type: "2",
    goodsImg: "https://youke1.picui.cn/s1/2025/08/30/68b2eb549371a.png"
  },
])

/** ---------------- 整屏滚动逻辑（保留原功能） ---------------- **/
const activeIndex = ref(0) // 当前激活的屏幕索引
const fullpage = ref(null) // 整屏容器DOM引用

// 点击导航点跳转对应屏幕
const scrollToSection = (index) => {
  const el = fullpage.value.children[index]
  el.scrollIntoView({ behavior: "smooth" })
  activeIndex.value = index
}

onMounted(() => {
  // 监听滚动，更新导航点激活状态
  fullpage.value.addEventListener("scroll", () => {
    const sections = fullpage.value.children
    let current = 0
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].getBoundingClientRect().top >= 0) {
        current = i
        break
      }
    }
    activeIndex.value = current
  })
})
</script>

<style scoped>
/* 首页基础样式（移除原地图相关样式，仅保留其他屏样式） */
/* .fullpage-wrapper {
 height: calc(100vh - 100px);
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  position: relative;
} */

/* .fullpage-section {
  height: 100vh;
  scroll-snap-align: start;
  display: flex;
  justify-content: center;
  align-items: center;
} */

/* 第一屏：视频 */
.section-video {
  background: #000;
}

/* 第二屏：轮播 */
.section-swiper {
  background: #f5f5f5;
}

/* 第四屏：联系我们 */
.section-empty {
  background: linear-gradient(#D0BDAC, #F4ECE1);
}

.section-empty-inner {
  width: 80%;
  margin: auto;
}

.section-empty-title {
  color: #A68167;
  font-size: 38px;
  padding: 110px;
  text-align: center;
}

.empty-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 150px;
}

.empty-list-item {
  border: 1px solid #CCB7A4;
  height: 160px;
  width: 30%;
  margin-top: 20px;


}

/* 右侧导航点 */
.page-dots {
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
  transition: background 0.3s, transform 0.3s;
}

.dot.active {
  background: #fff;
}
</style>